import { connect } from 'react-redux';
import modal from 'decorators/Modal/Modal';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import { cancelReservation, scheduleById } from 'redux/saga/entities/bound';
import { requestCancelReservation, watchCancelReservation } from '../Reservation.saga';
import { CancelReservationModal } from './CancelReservationModal';
import { loadReservationIfNeeded } from './CancelReservationModal.saga';
export var modalConfig = {
  lightClose: true
};

var mapReservationProps = function mapReservationProps(state, _ref) {
  var scheduleId = _ref.scheduleId,
      reservationId = _ref.reservationId;
  return {
    isReservationLoading: Boolean(scheduleId && scheduleById.loading(state, scheduleId)),
    reservationId: reservationId || deepExtract('reservation_id', scheduleById.data(state, scheduleId))
  };
};

export var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _mapReservationProps = mapReservationProps(state, ownProps),
      isReservationLoading = _mapReservationProps.isReservationLoading,
      reservationId = _mapReservationProps.reservationId;

  return {
    isCancellationError: Boolean(cancelReservation.error(state, reservationId)),
    isCancellationPending: cancelReservation.loading(state, reservationId),
    isCancelled: (cancelReservation.data(state, reservationId) || {}).id === reservationId,
    isReservationLoading: isReservationLoading,
    reservationId: reservationId
  };
};
export var mapDispatchToProps = {
  requestCancelReservation: requestCancelReservation
};
export var CancelReservationModalContainer = decorateWith(modal(modalConfig), withSagas({
  load: loadReservationIfNeeded,
  watch: watchCancelReservation
}), connect(mapStateToProps, mapDispatchToProps), withName('CancelReservationModalContainer'))(CancelReservationModal);